<form
    novalidate
    #propertyagentProfilePhotoForm="ngForm"
>
    <tg-row>
        <tg-col>
            <div class="property-agent-profile-photo__label p-label">
                Add a profile photo
                <span class="optional"> (optional)</span>
            </div>
        </tg-col>
    </tg-row>
    <tg-row class="profile-photo-info" *ngIf="isPhotoRemovalDisabled">
        <tg-info-box>
            To update the profile photo for this contact on the listing, update the agent’s
             <a target=“_blank” href="https://onehub.co.nz">OneHub</a> profile.
        </tg-info-box>
    </tg-row>
    <tg-row class="profile-photo-info" *ngIf="!isPhotoRemovalDisabled">
        <tg-info-box>
            <ul style="margin-left: 15px; list-style-type: disc">
                <li>
                    To display the contacts's profile photo, promote your listing with a marketing package.
                </li>
                <li>
                    If the contact is a licensed agent and has an active
                     <a target="_blank" href="https://onehub.co.nz">OneHub</a> profile,
                     you don't need to upload a photo as their OneHub profile photo will be displayed on the listing.
                </li>
            </ul>
        </tg-info-box>
    </tg-row>
    <tg-row
        aria-label="Profile photo"
        role="list"
        tgDropGrid
    >
        <tg-col
            *ngIf="photo"
            aria-label="Profile photo"
            class="property-agent-profile-photo__item-col"
            role="listitem"
            tgDrag
            sm="6"
            md="4"
        >
            <tm-list-photo-card
                [photo]="photo"
                attr.aria-label="Profile photo"
                tabindex="0"
            >
            </tm-list-photo-card>
            <button tgButton2 linkStyle *ngIf="!isPhotoRemovalDisabled"
                type="button"
                class="btn-remove-profile-image"
                (click)="removeProfileImage()">
                <ng-container>
                    <tg-icon name="bin" alt="Remove profile photo"></tg-icon>
                    <span>Remove profile image</span>
                </ng-container>
            </button>
        </tg-col>
        <tg-col
            *ngIf="!photo"
            aria-label="file upload area"
            class="property-agent-profile-photo__photo-picker-col"
            sm="6"
            md="5"
            lg="4"
        >
            <tg-aspect-ratio
                class="property-agent-profile-photo__photo-picker-aspect-ratio"
                ratio="1x1"
            >
                <tm-list-photo-picker
                    (photosAreUploading)="onAgentPhotoUploading()"
                    (photosUploaded)="onAgentPhotoUploaded($event)"
                    [isFileReaderApiAvailable]="isFileReaderApiAvailable"
                    [isAgentPhoto]="true"
                    name="photoUploader"
                    ngModel
                >
                    <tg-drop-zone
                        class="property-agent-profile-photo__photo-picker-dropzone"
                    >
                        Upload
                        <tg-icon alt="add profile photo" name="upload">
                        </tg-icon>
                        <tg-drop-zone-description>
                            or drag and drop here
                        </tg-drop-zone-description>
                    </tg-drop-zone>
                </tm-list-photo-picker>
            </tg-aspect-ratio>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col>
            <span *ngIf="!photo && !isInvalidPhoto">The photo must be a square (1:1 ratio)</span>
        </tg-col>
    </tg-row>
    <tg-row *ngIf="isInvalidPhoto">
        <tg-col>
            <tg-info-box tgStyle="warning">
                <tg-icon name="basic-warning-framed" role="presentation">
                </tg-icon>
                <p
                    role="alert"
                    *ngFor="
                        let error of invalidFilesErrorMessages | keyvalue
                    "
                >
                    <ng-template
                        [ngIf]="error.value.length > 1"
                        [ngIfElse]="singleFile"
                    >
                        The following files weren't uploaded{{
                            getErrorDetail(error.key)
                        }}.
                        <ul tgList2 type="bullet" compact>
                            <li *ngFor="let v of error.value">{{ v }}</li>
                        </ul>
                    </ng-template>
                    <ng-template #singleFile>
                        {{ error.value[0] }} could not be uploaded{{
                            getErrorDetail(error.key)
                        }}.
                    </ng-template>
                </p>
            </tg-info-box>
        </tg-col>
    </tg-row>
</form>